<template>
  <div class="aBitOfMargin"> <!-- navMargin -->
    <NavBar :transparent-on-top="true"></NavBar>
    <div v-if="!isLoggedIn">
      <h1>No has iniciado sesión</h1>
    </div>
    <div v-if="isLoggedIn && finishedLoading">
      <vs-row justify="center">
        <vs-col w="9" xs="12" style="background-color: #313131; border-radius: 10px 10px; padding: 20px; min-height: 400px">
          <div style="text-align: center;"><h2>Mis favoritos</h2></div>
          <vs-button-group>
            <vs-button style="min-width: 200px" size="xl" flat icon :active="activeList === 'watch'" @click="activeList = 'watch'">
              <i class="bx bx-tv" style="margin-right: 10px"></i> TV
            </vs-button>
            <vs-button style="min-width: 200px" size="xl" flat icon :active="activeList === 'read'" @click="activeList = 'read'">
              <i class="bx bxs-book" style="margin-right: 10px"></i> Lectura
            </vs-button>
          </vs-button-group>
          <div v-if="activeList === 'watch'">
            <div v-for="likedSerie in likedSeries" :key="likedSerie.idSerie" class="liked" style="margin-top: 20px;">
              <vs-card type="3" style="width: 100%;">
                <template #title>
                  <h3>{{ likedSerie.nombre }}<span class="badge tip middle">{{ likedSerie.type }}</span></h3>
                </template>
                <template #img>
                  <div class="ratio ratio-16x9"> <img :src="likedSerie.poster_horizontal" :alt="'Poster horizontal de ' + likedSerie.nombre"> </div>
                </template>
                <template #text><p>{{ likedSerie.descripcion }}</p></template>
                <template #interactions>
                  <vs-button danger icon>
                    <i class='bx bxs-heart'></i>
                  </vs-button>
                  <!-- <vs-button class="btn-chat" shadow primary> <i class='bx bx-chat'></i> <span class="span"> 54 </span> </vs-button> -->
                </template>
              </vs-card>
            </div>
          </div>
          <div v-if="activeList === 'read'">
            <div v-for="likedBook in likedBooks" :key="likedBook.idLibro" class="liked" style="margin-top: 20px;">
              <vs-card type="3" style="width: 100%;">
                <template #title>
                  <h3>{{ likedBook.nombre }}</h3>
                </template>
                <template #img>
                  <img :src="likedBook.poster_horizontal" alt="">
                </template>
                <template #text>
                  <p>
                    {{ likedBook.descripcion }}
                  </p>
                </template>
              </vs-card>
            </div>
          </div>
        </vs-col>
      </vs-row>
      <br>
      <div style="display: flex;align-items: center;justify-content: center">
        <!-- <vs-button primary>Guardar</vs-button> -->
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import NavBar from "../components/NavBar";

export default {
  name: "MyLiked",
  components: { NavBar },
  data() {
    return {
      account: {},
      isLoggedIn: false,
      likedSeries: [],
      likedBooks: [],
      finishedLoading: false,
      activeList: 'watch'
    }
  },
  async beforeMount() {
    this.isLoggedIn = this.$store.state.auth.isLoggedIn;

    if (this.isLoggedIn === true) {
      this.account.token = this.$store.state.auth.token;
      this.account.username = this.$store.state.auth.username;
    }
  },
  async created() {
    if (this.$store.state.auth.isLoggedIn) {
      await axios
          .post(`https://api.videnti.co/user/favorites/get`, new URLSearchParams(), { headers: { "Content-Type": 'application/x-www-form-urlencoded', 'Authorization': 'Bearer ' + this.$store.state.auth.token, } })
          .then(responseRC => {
            this.likedSeries = responseRC.data;
            if (responseRC.data.error) { this.checkIfJWTExpired(responseRC.data.message); }
          });
      await axios
          .post(`https://api.videnti.co/user/favorites/get?type=read`, new URLSearchParams(), { headers: { "Content-Type": 'application/x-www-form-urlencoded', 'Authorization': 'Bearer ' + this.$store.state.auth.token, } })
          .then(responseRC => {
            this.likedBooks = responseRC.data;
            if (responseRC.data.error) { this.checkIfJWTExpired(responseRC.data.message); }
          });
      this.finishedLoading = true
    } else {
      this.finishedLoading = true
    }
  },
  methods: {
    async removeFavorite() {

    }
  }
}
</script>

<style scoped>
.aBitOfMargin {
  margin-top: 134px;
}

.badge {
  font-size: .6rem !important;
  margin-left: 10px;
}

</style>
<style>
.liked .vs-card-content.type-3 .vs-card {
  max-width: none !important;
}

.liked .vs-card-content.type-3 .vs-card__img img {
  max-width: 500px;
  min-width: auto !important;
}

.liked .vs-card-content.type-3 .vs-card__img {
  width: 50% !important;
}

.liked .vs-card-content.type-3 .vs-card__img .vs-card__interactions {
  left: auto;
  right: 0 !important;
}
</style>
